import { createFileRoute, redirect } from '@tanstack/react-router'

/** 站点根:统一落到概览(未登录会被 /_authed 的门禁再弹去 /login)。 */
export const Route = createFileRoute('/')({
  beforeLoad: () => {
    throw redirect({ to: '/dashboard' })
  },
})
